import React from 'react';

import Essentials from './Section/Essentials';
import Infographics from './Section/Infographics';
import Video from './Section/Video';
import Relations from './Section/Relations';


import { Col, Row, Tabs } from 'antd';

const { TabPane } = Tabs;

class ExampleUpdate extends React.Component {

  render() {
    return (
      <div style={{padding: 80}}>
        <Row>
          <Col span={21} offset={3}>
          <Tabs tabPosition="left">

            <TabPane tab="Esenciales" key="1">
              <Essentials {...this.props} />
            </TabPane>

            <TabPane tab="Imágenes y gráficos" key="2">
              <Infographics {...this.props} />
            </TabPane>

            <TabPane tab="Vídeo del curso" key="3">
              <Video {...this.props} />
            </TabPane>

            <TabPane tab="Curso teórico vinculado" key="6">
              <Relations {...this.props} />
            </TabPane>

          </Tabs>
          </Col>
        </Row>
      </div>
    );
  };
}


export default ExampleUpdate;
